export const AuthType = {
  Classic: "classic",
  Sso: "sso",
  OAuth: "oauth",
} as const

export type TAuthType = (typeof AuthType)[keyof typeof AuthType]

export function getAuthType(authTypeParam: string | null): TAuthType {
  switch (authTypeParam) {
    case "oauth":
      return AuthType.OAuth
    case "sso":
      return AuthType.Sso
    default:
      return AuthType.Classic
  }
}
